export default __webpack_public_path__ + "static/media/loading_gif.946a0b48.gif";